import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Globals } from "./constants";
import { getCDNUrl } from "./HelperFunctions";

class Footer extends Component {
  componentDidMount;

  render() {
    return (
      <footer>
        <div className="container py-5">
          <div className="d-flex flex-column d-lg-none">
            <div className="mr-auto w-100 d-flex justify-content-center">
              <div className="d-flex flex-column text-center">
              
              </div>
            </div>
            <div className="mx-auto mt-5 d-flex justify-content-center">
              &copy; 2022 Cricworld. All rights reserved
            </div>
            <div className="ml-auto mt-5 w-100 d-flex justify-content-center">
              {/* <div>
                <img
                  onClick={() =>
                    Globals.telco === "mobilink" ? 
                    window.open(
                      "https://itunes.apple.com/pk/app/jazz-cricket/id1371362811?mt=8"
                    ) : 
                    window.open(
                      "https://apps.apple.com/pk/app/cricwick-pakistan/id1461475044"
                    )
                  }
                  height="50"
                  src={getCDNUrl("/images/ios_icon.png")}
                  style={{ cursor: "pointer" }}
                  alt=""
                />
                <img
                  onClick={() =>
                    Globals.telco === "mobilink" ? 
                      window.open(
                        "https://play.google.com/store/apps/details?id=com.Khaleef.CricWickMobilink"
                      ) :
                      window.open(
                        "https://play.google.com/store/apps/details?id=com.Khaleef.CricWick.TelenorZong",
                    )
                  }
                  height="50"
                  src={getCDNUrl("/images/android_icon.png")}
                  style={{ cursor: "pointer" }}
                  alt=""
                />
                <img
                  onClick={() =>
                    Globals.telco === "mobilink" ? 
                    window.open(
                      "https://appgallery.huawei.com/#/app/C100858031"
                     ) :
                    window.open(
                      "https://appgallery.huawei.com/#/app/C100957899"
                    )
                  }
                  height="50"
                  src={getCDNUrl("/images/huawie_icon.png")}
                  style={{ cursor: "pointer" }}
                  alt=""
                />
              </div> */}
            </div>
          </div>

          <div className="d-lg-flex d-none">
            <div className="mr-auto d-flex flex-column">
              {
              Globals.product === "Cricwick" &&
              <>
                <Link to="/mystars11-tnc">MyStars11 - Terms and Conditions</Link>
                <Link to="/mystars11-faqs">MyStars11 - FAQs</Link>
              </>
              } 
            </div>
            <div className="mx-auto">
              &copy; 2022 Cricworld. All rights reserved
            </div>
            <div className="ml-auto">
              {/* <img
                onClick={() =>
                  Globals.telco === "mobilink" ? 
                    window.open(
                      "https://itunes.apple.com/pk/app/jazz-cricket/id1371362811?mt=8"
                    ) :
                    window.open(
                      "https://apps.apple.com/pk/app/cricwick-pakistan/id1461475044"
                  )
                }
                height="50"
                src={getCDNUrl("/images/ios_icon.png")}
                style={{ cursor: "pointer" }}
                alt=""
              />
              <img
                onClick={() =>
                  Globals.telco === "mobilink" ? 
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.Khaleef.CricWickMobilink"
                    ) :
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.Khaleef.CricWick.TelenorZong",
                  )
                }
                height="50"
                src={getCDNUrl("/images/android_icon.png")}
                style={{ cursor: "pointer" }}
                alt=""
              />
              <img
                onClick={() => 
                  Globals.telco === "mobilink" ? 
                  window.open(
                    "https://appgallery.huawei.com/#/app/C100858031"
                  ) :
                  window.open("https://appgallery.huawei.com/#/app/C100957899")}
                height="50"
                src={getCDNUrl("/images/huawie_icon.png")}
                style={{ cursor: "pointer" }}
                alt=""
              /> */}
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
